import { createAnatomy as g } from "../../anatomy/dist/index.mjs";
import { createScope as m, isSafari as p, MAX_Z_INDEX as b } from "../../dom-query/dist/index.mjs";
import { roundToDevicePixel as u, wrap as c } from "../../../../../../@zag-js/number-utils/dist/index.mjs";
var a = g("numberInput").parts(
  "root",
  "label",
  "input",
  "control",
  "incrementTrigger",
  "decrementTrigger",
  "scrubber"
);
a.build();
var n = m({
  getRootId: (e) => {
    var r;
    return ((r = e.ids) == null ? void 0 : r.root) ?? `number-input:${e.id}`;
  },
  getInputId: (e) => {
    var r;
    return ((r = e.ids) == null ? void 0 : r.input) ?? `number-input:${e.id}:input`;
  },
  getIncrementTriggerId: (e) => {
    var r;
    return ((r = e.ids) == null ? void 0 : r.incrementTrigger) ?? `number-input:${e.id}:inc`;
  },
  getDecrementTriggerId: (e) => {
    var r;
    return ((r = e.ids) == null ? void 0 : r.decrementTrigger) ?? `number-input:${e.id}:dec`;
  },
  getScrubberId: (e) => {
    var r;
    return ((r = e.ids) == null ? void 0 : r.scrubber) ?? `number-input:${e.id}:scrubber`;
  },
  getCursorId: (e) => `number-input:${e.id}:cursor`,
  getLabelId: (e) => {
    var r;
    return ((r = e.ids) == null ? void 0 : r.label) ?? `number-input:${e.id}:label`;
  },
  getInputEl: (e) => n.getById(e, n.getInputId(e)),
  getIncrementTriggerEl: (e) => n.getById(e, n.getIncrementTriggerId(e)),
  getDecrementTriggerEl: (e) => n.getById(e, n.getDecrementTriggerId(e)),
  getScrubberEl: (e) => n.getById(e, n.getScrubberId(e)),
  getCursorEl: (e) => n.getDoc(e).getElementById(n.getCursorId(e)),
  getPressedTriggerEl: (e, r = e.hint) => {
    let t = null;
    return r === "increment" && (t = n.getIncrementTriggerEl(e)), r === "decrement" && (t = n.getDecrementTriggerEl(e)), t;
  },
  setupVirtualCursor(e) {
    if (!p())
      return n.createVirtualCursor(e), () => {
        var r;
        (r = n.getCursorEl(e)) == null || r.remove();
      };
  },
  preventTextSelection(e) {
    const r = n.getDoc(e), t = r.documentElement, i = r.body;
    return i.style.pointerEvents = "none", t.style.userSelect = "none", t.style.cursor = "ew-resize", () => {
      i.style.pointerEvents = "", t.style.userSelect = "", t.style.cursor = "", t.style.length || t.removeAttribute("style"), i.style.length || i.removeAttribute("style");
    };
  },
  getMousementValue(e, r) {
    const t = u(r.movementX), i = u(r.movementY);
    let o = t > 0 ? "increment" : t < 0 ? "decrement" : null;
    e.isRtl && o === "increment" && (o = "decrement"), e.isRtl && o === "decrement" && (o = "increment");
    const s = {
      x: e.scrubberCursorPoint.x + t,
      y: e.scrubberCursorPoint.y + i
    }, d = n.getWin(e).innerWidth, l = u(7.5);
    return s.x = c(s.x + l, d) - l, { hint: o, point: s };
  },
  createVirtualCursor(e) {
    const r = n.getDoc(e), t = r.createElement("div");
    t.className = "scrubber--cursor", t.id = n.getCursorId(e), Object.assign(t.style, {
      width: "15px",
      height: "15px",
      position: "fixed",
      pointerEvents: "none",
      left: "0px",
      top: "0px",
      zIndex: b,
      transform: e.scrubberCursorPoint ? `translate3d(${e.scrubberCursorPoint.x}px, ${e.scrubberCursorPoint.y}px, 0px)` : void 0,
      willChange: "transform"
    }), t.innerHTML = `
        <svg width="46" height="15" style="left: -15.5px; position: absolute; top: 0; filter: drop-shadow(rgba(0, 0, 0, 0.4) 0px 1px 1.1px);">
          <g transform="translate(2 3)">
            <path fill-rule="evenodd" d="M 15 4.5L 15 2L 11.5 5.5L 15 9L 15 6.5L 31 6.5L 31 9L 34.5 5.5L 31 2L 31 4.5Z" style="stroke-width: 2px; stroke: white;"></path>
            <path fill-rule="evenodd" d="M 15 4.5L 15 2L 11.5 5.5L 15 9L 15 6.5L 31 6.5L 31 9L 34.5 5.5L 31 2L 31 4.5Z"></path>
          </g>
        </svg>`, r.body.appendChild(t);
  }
});
export {
  a as anatomy
};
